import React from 'react'
import _ from 'lodash'
import './StepDots.scss'
const StepDots = ({stepCount, step}) => {
  return (
    step <= stepCount && (
      <div className="c-step-dots">
        {[...Array(stepCount)].map((e, i) => (
          <div
            className={`c-step-dots__item ${i + 1 === step && 'c-step-dots__item--selected'}`}
          ></div>
        ))}
      </div>
    )
  )
}

export default StepDots
